// Mock data for National Democratic Party of Bangladesh

export const partyInfo = {
  name: {
    en: "National Democratic Party of Bangladesh",
    bn: "বাংলাদেশ ন্যাশনাল ডেমোক্রেটিক পার্টি"
  },
  shortName: {
    en: "NDP Bangladesh",
    bn: "এনডিপি বাংলাদেশ"
  },
  slogan: {
    en: "Building a Progressive Bangladesh",
    bn: "অগ্রগতিশীল বাংলাদেশ গড়ি"
  },
  founded: "2024",
  address: {
    en: "83/B Siddheswari Circular Road, 13th Floor - 1303, Dhaka- 1217",
    bn: "৮৩/বি সিদ্ধেশ্বরী সার্কুলার রোড, ১৩তম তলা - ১৩০৩, ঢাকা- ১২১৭"
  },
  phones: ["01732-341999", "01552-301694"],
  email: "info@ndpbd.com",
  bkashQR: "https://customer-assets.emergentagent.com/job_87e159dc-3189-4727-ae1e-bf728f7f511e/artifacts/zsab08nh_qr_code.png",
  flagImage: "https://customer-assets.emergentagent.com/job_d08f181b-535a-4f44-a18a-b53130363228/artifacts/lff4y1ut_PARTY%20FLAG.jpg"
};

export const heroSlides = [
  {
    id: 1,
    image: "https://ndpbd.com/images/slider/1.jpeg",
    title: { en: "Building a Better Bangladesh", bn: "একটি উন্নত বাংলাদেশ গড়ি" },
    subtitle: { en: "Unity, Progress, Democracy", bn: "ঐক্য, উন্নতি, গণতন্ত্র" }
  },
  {
    id: 2,
    image: "https://ndpbd.com/images/slider/2.jpeg",
    title: { en: "Youth Empowerment", bn: "যুব ক্ষমতায়ন" },
    subtitle: { en: "Creating opportunities for the next generation", bn: "নতুন প্রজন্মের জন্য সুযোগ সৃষ্টি" }
  },
  {
    id: 3,
    image: "https://ndpbd.com/images/slider/3.jpeg",
    title: { en: "Grassroots Development", bn: "তৃণমূল উন্নয়ন" },
    subtitle: { en: "Empowering communities across Bangladesh", bn: "সারাদেশে সম্প্রদায়কে ক্ষমতায়ন" }
  },
  {
    id: 4,
    image: "https://ndpbd.com/images/slider/4.jpeg",
    title: { en: "Education for All", bn: "সবার জন্য শিক্ষা" },
    subtitle: { en: "Building a knowledgeable nation", bn: "জ্ঞানী জাতি গড়ি" }
  },
  {
    id: 5,
    image: "https://ndpbd.com/images/slider/5.jpeg",
    title: { en: "Women Leadership", bn: "নারী নেতৃত্ব" },
    subtitle: { en: "Equal representation, equal rights", bn: "সমান প্রতিনিধিত্ব, সমান অধিকার" }
  }
];

export const leaders = [
  {
    id: 1,
    name: { en: "Dr. Ahmed Rahman", bn: "ডঃ আহমেদ রহমান" },
    position: { en: "Party President", bn: "দলের সভাপতি" },
    image: "https://images.unsplash.com/photo-1560250097-0b93528c311a?w=400&h=400&fit=crop",
    bio: {
      en: "A visionary leader committed to democratic values and inclusive governance.",
      bn: "গণতান্ত্রিক মূল্যবোধ এবং অন্তর্ভুক্তিমূলক শাসনে প্রতিশ্রুতিবদ্ধ একজন দূরদর্শী নেতা।"
    }
  },
  {
    id: 2,
    name: { en: "Fatima Khatun", bn: "ফাতিমা খাতুন" },
    position: { en: "General Secretary", bn: "সাধারণ সম্পাদক" },
    image: "https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=400&h=400&fit=crop",
    bio: {
      en: "Championing women's rights and social justice across Bangladesh.",
      bn: "সমগ্র বাংলাদেশে নারী অধিকার এবং সামাজিক ন্যায়বিচারের পক্ষে সংগ্রামী।"
    }
  },
  {
    id: 3,
    name: { en: "Kamal Hossain", bn: "কামাল হোসেন" },
    position: { en: "Vice President", bn: "সহ-সভাপতি" },
    image: "https://images.unsplash.com/photo-1472099645785-5658abf4ff4e?w=400&h=400&fit=crop",
    bio: {
      en: "Economic development advocate with grassroots experience.",
      bn: "তৃণমূল অভিজ্ঞতা সহ অর্থনৈতিক উন্নয়নের প্রবক্তা।"
    }
  },
  {
    id: 4,
    name: { en: "Nasrin Sultana", bn: "নাসরিন সুলতানা" },
    position: { en: "Youth Wing President", bn: "যুব শাখার সভাপতি" },
    image: "https://images.unsplash.com/photo-1551836022-d5d88e9218df?w=400&h=400&fit=crop",
    bio: {
      en: "Leading the youth movement for progressive change.",
      bn: "প্রগতিশীল পরিবর্তনের জন্য যুব আন্দোলনের নেতৃত্ব দিচ্ছেন।"
    }
  }
];

export const timeline = [
  {
    year: "1989",
    title: { en: "Party Founded", bn: "দল প্রতিষ্ঠা" },
    description: {
      en: "The National Democratic Party (NDP) was founded on 11 September 1989 by Salahuddin Quader Chowdhury and Anowar Zahid, establishing a new nationalist political force in Bangladesh with the slogan 'Bangladesh Zindabad.'",
      bn: "১১ সেপ্টেম্বর ১৯৮৯ সালে সালাহউদ্দিন কাদের চৌধুরী ও আনোয়ার জাহিদ 'বাংলাদেশ জিন্দাবাদ' স্লোগানে ন্যাশনাল ডেমোক্রেটিক পার্টি (এনডিপি) প্রতিষ্ঠা করেন, বাংলাদেশে একটি নতুন জাতীয়তাবাদী রাজনৈতিক শক্তি হিসেবে।"
    }
  },
  {
    year: "1991",
    title: { en: "First Parliamentary Victory", bn: "প্রথম সংসদীয় বিজয়" },
    description: {
      en: "Salahuddin Quader Chowdhury was elected to the Bangladesh Parliament from the Chittagong-6 constituency in the 1991 general election, giving NDP its first parliamentary representation.",
      bn: "১৯৯১ সালের সাধারণ নির্বাচনে সালাহউদ্দিন কাদের চৌধুরী চট্টগ্রাম-৬ আসন থেকে বাংলাদেশ সংসদে নির্বাচিত হন, এনডিপি তার প্রথম সংসদীয় প্রতিনিধিত্ব অর্জন করে।"
    }
  },
  {
    year: "1990s",
    title: { en: "Championing Nationalist Politics", bn: "জাতীয়তাবাদী রাজনীতির পুরোধা" },
    description: {
      en: "Throughout the 1990s, NDP established itself as a significant voice in Bangladeshi nationalist politics, advocating for democratic governance, economic reform, and national sovereignty.",
      bn: "১৯৯০-এর দশক জুড়ে এনডিপি বাংলাদেশের জাতীয়তাবাদী রাজনীতিতে একটি গুরুত্বপূর্ণ কণ্ঠস্বর হিসেবে প্রতিষ্ঠিত হয়, গণতান্ত্রিক শাসন, অর্থনৈতিক সংস্কার এবং জাতীয় সার্বভৌমত্বের পক্ষে সোচ্চার হয়।"
    }
  },
  {
    year: "2000s",
    title: { en: "Alliance Politics & Democratic Movement", bn: "জোট রাজনীতি ও গণতান্ত্রিক আন্দোলন" },
    description: {
      en: "NDP actively participated in alliance politics, joining broader nationalist coalitions to strengthen democratic institutions and advocate for free and fair elections in Bangladesh.",
      bn: "এনডিপি সক্রিয়ভাবে জোট রাজনীতিতে অংশগ্রহণ করে, গণতান্ত্রিক প্রতিষ্ঠান শক্তিশালীকরণ এবং বাংলাদেশে অবাধ ও সুষ্ঠু নির্বাচনের পক্ষে বৃহত্তর জাতীয়তাবাদী জোটে যোগ দেয়।"
    }
  },
  {
    year: "2014",
    title: { en: "National Democratic Front", bn: "জাতীয় গণতান্ত্রিক ফ্রন্ট" },
    description: {
      en: "NDP joined the National Democratic Front, an alliance of 10 nationalist parties, in September 2014, strengthening the party's position in the broader nationalist movement for democratic governance.",
      bn: "২০১৪ সালের সেপ্টেম্বরে এনডিপি ১০টি জাতীয়তাবাদী দলের জোট জাতীয় গণতান্ত্রিক ফ্রন্টে যোগদান করে, গণতান্ত্রিক শাসনের জন্য বৃহত্তর জাতীয়তাবাদী আন্দোলনে দলের অবস্থান শক্তিশালী করে।"
    }
  },
  {
    year: "2017",
    title: { en: "New Leadership Era", bn: "নতুন নেতৃত্বের যুগ" },
    description: {
      en: "Kari Mohammad Abu Taher became the Chairman and President of NDP on 17 October 2017, ushering in a new era of organisational reform, grassroots expansion and renewed commitment to nationalist ideals.",
      bn: "১৭ অক্টোবর ২০১৭ সালে কারী মোহাম্মদ আবু তাহের এনডিপির চেয়ারম্যান ও সভাপতি হন, সাংগঠনিক সংস্কার, তৃণমূল সম্প্রসারণ এবং জাতীয়তাবাদী আদর্শের প্রতি নতুন প্রতিশ্রুতির একটি নতুন যুগের সূচনা করেন।"
    }
  },
  {
    year: "2022",
    title: { en: "12 Party Alliance", bn: "১২ দলীয় জোট" },
    description: {
      en: "NDP took a bold step by forming the 12 Party Alliance, charting an independent political path while maintaining its commitment to democratic values and nationalist principles.",
      bn: "এনডিপি ১২ দলীয় জোট গঠনের মাধ্যমে একটি সাহসী পদক্ষেপ নেয়, গণতান্ত্রিক মূল্যবোধ ও জাতীয়তাবাদী নীতির প্রতি প্রতিশ্রুতি বজায় রেখে একটি স্বাধীন রাজনৈতিক পথ অবলম্বন করে।"
    }
  },
  {
    year: "2024",
    title: { en: "July Mass Uprising", bn: "জুলাই গণঅভ্যুত্থান" },
    description: {
      en: "NDP stood with the people during the historic July Mass Uprising (Gano-Abhyutthan), a pivotal democratic movement that reshaped the political landscape of Bangladesh.",
      bn: "ঐতিহাসিক জুলাই গণঅভ্যুত্থানে এনডিপি জনগণের পাশে দাঁড়ায়, একটি যুগান্তকারী গণতান্ত্রিক আন্দোলন যা বাংলাদেশের রাজনৈতিক প্রেক্ষাপটকে নতুন রূপ দেয়।"
    }
  },
  {
    year: "2025",
    title: { en: "Grassroots Expansion", bn: "তৃণমূল সম্প্রসারণ" },
    description: {
      en: "NDP intensified its grassroots organisational work across all 64 districts, launching youth mobilisation campaigns, welfare programmes and establishing a strong digital presence to connect with new-generation supporters.",
      bn: "এনডিপি সকল ৬৪ জেলায় তৃণমূল সাংগঠনিক কাজ জোরদার করে, যুব সংগঠন প্রচারণা, কল্যাণ কর্মসূচি চালু করে এবং নতুন প্রজন্মের সমর্থকদের সাথে সংযুক্ত করতে একটি শক্তিশালী ডিজিটাল উপস্থিতি গড়ে তোলে।"
    }
  },
  {
    year: "2026",
    title: { en: "37th Anniversary Celebration", bn: "৩৭তম প্রতিষ্ঠাবার্ষিকী উদযাপন" },
    description: {
      en: "NDP celebrated its 37th founding anniversary with a grand rally from Nayapaltan to the National Press Club and a discussion session at the Kazi Nazrul Islam Auditorium, attended by party leaders, allied parties and supporters from across the country.",
      bn: "এনডিপি নয়াপল্টন থেকে জাতীয় প্রেসক্লাব পর্যন্ত একটি বিশাল র‍্যালি এবং কাজী নজরুল ইসলাম মিলনায়তনে আলোচনা সভার মধ্য দিয়ে তার ৩৭তম প্রতিষ্ঠাবার্ষিকী উদযাপন করে, যেখানে দলীয় নেতা, মিত্র দল এবং সারা দেশ থেকে সমর্থকরা অংশগ্রহণ করেন।"
    }
  }
];

export const newsArticles = [
  {
    id: 1,
    title: {
      en: "NDP Announces Economic Reform Agenda",
      bn: "এনডিপি অর্থনৈতিক সংস্কার এজেন্ডা ঘোষণা করেছে"
    },
    excerpt: {
      en: "Party leadership unveils comprehensive plan for economic growth and job creation.",
      bn: "দলীয় নেতৃত্ব অর্থনৈতিক প্রবৃদ্ধি এবং কর্মসংস্থান সৃষ্টির জন্য ব্যাপক পরিকল্পনা উন্মোচন করেছে।"
    },
    date: "2025-03-15",
    image: "https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=800&h=400&fit=crop",
    category: { en: "Policy", bn: "নীতি" }
  },
  {
    id: 2,
    title: {
      en: "Women's Wing Hosts Leadership Summit",
      bn: "মহিলা শাখা নেতৃত্ব সম্মেলনের আয়োজন করেছে"
    },
    excerpt: {
      en: "Over 500 women leaders gather to discuss empowerment strategies.",
      bn: "৫০০ এরও বেশি নারী নেতা ক্ষমতায়ন কৌশল নিয়ে আলোচনা করতে সমবেত হন।"
    },
    date: "2025-03-10",
    image: "https://images.unsplash.com/photo-1511632765486-a01980e01a18?w=800&h=400&fit=crop",
    category: { en: "Events", bn: "ইভেন্ট" }
  },
  {
    id: 3,
    title: {
      en: "Youth Employment Initiative Launched",
      bn: "যুব কর্মসংস্থান উদ্যোগ চালু হয়েছে"
    },
    excerpt: {
      en: "New program aims to create 100,000 jobs for young Bangladeshis.",
      bn: "নতুন কর্মসূচির লক্ষ্য তরুণ বাংলাদেশীদের জন্য ১,০০,০০০ কর্মসংস্থান সৃষ্টি করা।"
    },
    date: "2025-03-05",
    image: "https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=800&h=400&fit=crop",
    category: { en: "Programs", bn: "কর্মসূচি" }
  },
  {
    id: 4,
    title: {
      en: "Education Reform Proposal Released",
      bn: "শিক্ষা সংস্কার প্রস্তাব প্রকাশিত"
    },
    excerpt: {
      en: "Party presents vision for modernizing Bangladesh's education system.",
      bn: "দল বাংলাদেশের শিক্ষা ব্যবস্থা আধুনিকীকরণের জন্য দৃষ্টিভঙ্গি উপস্থাপন করেছে।"
    },
    date: "2025-02-28",
    image: "https://images.unsplash.com/photo-1503676260728-1c00da094a0b?w=800&h=400&fit=crop",
    category: { en: "Policy", bn: "নীতি" }
  }
];

export const galleryImages = [
  { id: 1, url: "https://ndpbd.com/images/community/1.jpeg", caption: { en: "Community Meeting", bn: "সম্প্রদায় সভা" } },
  { id: 2, url: "https://ndpbd.com/images/community/2.jpeg", caption: { en: "Rally in Dhaka", bn: "ঢাকায় সমাবেশ" } },
  { id: 3, url: "https://ndpbd.com/images/community/3.jpeg", caption: { en: "Youth Conference", bn: "যুব সম্মেলন" } },
  { id: 4, url: "https://ndpbd.com/images/community/4.jpeg", caption: { en: "Women's Gathering", bn: "মহিলা সমাবেশ" } },
  { id: 5, url: "https://ndpbd.com/images/community/5.jpeg", caption: { en: "Village Outreach", bn: "গ্রাম সেবা" } },
  { id: 6, url: "https://ndpbd.com/images/community/6.jpeg", caption: { en: "Party Workers", bn: "দলীয় কর্মী" } },
  { id: 7, url: "https://ndpbd.com/images/community/7.jpeg", caption: { en: "Campaign Event", bn: "প্রচারণা অনুষ্ঠান" } },
  { id: 8, url: "https://ndpbd.com/images/community/8.jpeg", caption: { en: "Leadership Meeting", bn: "নেতৃত্ব সভা" } },
  { id: 9, url: "https://ndpbd.com/images/community/9.jpeg", caption: { en: "Street Campaign", bn: "রাস্তার প্রচার" } },
  { id: 10, url: "https://ndpbd.com/images/community/10.jpeg", caption: { en: "Press Conference", bn: "সংবাদ সম্মেলন" } },
  { id: 11, url: "https://ndpbd.com/images/community/11.jpeg", caption: { en: "Supporters Rally", bn: "সমর্থক সমাবেশ" } },
  { id: 12, url: "https://ndpbd.com/images/community/12.jpeg", caption: { en: "Community Service", bn: "সমাজসেবা" } }
];

export const manifesto = {
  en: {
    vision: "Building a democratic, inclusive, and prosperous Bangladesh where every citizen has equal opportunity.",
    priorities: [
      {
        title: "Education Reform",
        description: "Skill-based, inclusive, and technology-driven education system.",
        icon: "GraduationCap"
      },
      {
        title: "Youth Employment",
        description: "Support for startups, technical training, and entrepreneurship.",
        icon: "Users"
      },
      {
        title: "Healthcare Access",
        description: "Affordable, accessible, and rural-focused healthcare system.",
        icon: "Heart"
      },
      {
        title: "Women Leadership",
        description: "Equal representation and security in all sectors.",
        icon: "UserCheck"
      },
      {
        title: "Green Growth",
        description: "Sustainable agriculture and renewable energy adoption.",
        icon: "Leaf"
      },
      {
        title: "Digital Bangladesh",
        description: "Technology integration in governance and services.",
        icon: "Smartphone"
      }
    ]
  },
  bn: {
    vision: "একটি গণতান্ত্রিক, অন্তর্ভুক্তিমূলক এবং সমৃদ্ধ বাংলাদেশ গড়া যেখানে প্রতিটি নাগরিকের সমান সুযোগ রয়েছে।",
    priorities: [
      {
        title: "শিক্ষা সংস্কার",
        description: "দক্ষতাভিত্তিক, অন্তর্ভুক্তিমূলক ও প্রযুক্তিনির্ভর শিক্ষা।",
        icon: "GraduationCap"
      },
      {
        title: "তরুণদের কর্মসংস্থান",
        description: "স্টার্টআপ, কারিগরি প্রশিক্ষণ ও উদ্যোক্তাদের সহায়তা।",
        icon: "Users"
      },
      {
        title: "স্বাস্থ্যসেবা প্রবেশযোগ্যতা",
        description: "সুলভ, সহজলভ্য ও গ্রামীণভিত্তিক স্বাস্থ্যব্যবস্থা।",
        icon: "Heart"
      },
      {
        title: "নারী নেতৃত্ব",
        description: "সকল ক্ষেত্রে সমান প্রতিনিধিত্ব ও নিরাপত্তা।",
        icon: "UserCheck"
      },
      {
        title: "সবুজ প্রবৃদ্ধি",
        description: "টেকসই কৃষি ও নবায়নযোগ্য শক্তির ব্যবহার।",
        icon: "Leaf"
      },
      {
        title: "ডিজিটাল বাংলাদেশ",
        description: "শাসন এবং সেবায় প্রযুক্তির একীকরণ।",
        icon: "Smartphone"
      }
    ]
  }
};

export const events = [
  {
    id: 1,
    title: { en: "National Youth Convention 2025", bn: "জাতীয় যুব সম্মেলন ২০২৫" },
    date: "2025-04-15",
    location: { en: "Dhaka Convention Center", bn: "ঢাকা কনভেনশন সেন্টার" },
    description: {
      en: "Join thousands of young leaders to shape Bangladesh's future.",
      bn: "বাংলাদেশের ভবিষ্যৎ গঠনে হাজার হাজার তরুণ নেতার সাথে যোগ দিন।"
    }
  },
  {
    id: 2,
    title: { en: "Women Empowerment Summit", bn: "নারী ক্ষমতায়ন সম্মেলন" },
    date: "2025-04-20",
    location: { en: "Chittagong", bn: "চট্টগ্রাম" },
    description: {
      en: "Discussing strategies for gender equality and women's leadership.",
      bn: "লিঙ্গ সমতা এবং নারী নেতৃত্বের কৌশল নিয়ে আলোচনা।"
    }
  },
  {
    id: 3,
    title: { en: "Economic Policy Forum", bn: "অর্থনৈতিক নীতি ফোরাম" },
    date: "2025-05-10",
    location: { en: "Sylhet", bn: "সিলেট" },
    description: {
      en: "Expert panel discussion on economic development strategies.",
      bn: "অর্থনৈতিক উন্নয়ন কৌশল নিয়ে বিশেষজ্ঞ প্যানেল আলোচনা।"
    }
  }
];